import axios from "axios";
import { API_BASE_URL, buildAppPath } from "../utils/constants";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if we're on the login page or making auth requests
      // This allows login errors to be handled gracefully without redirecting
      const isAuthRequest = error.config?.url?.includes("/auth/") || 
                           error.config?.url?.includes("/whmcs-auth/");
      const isOnLoginPage = window.location.pathname.includes("/login");
      
      if (!isAuthRequest && !isOnLoginPage) {
        localStorage.removeItem("token");
        window.location.href = buildAppPath("/");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
